import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import Loader from '../components/common/Loader.jsx';
import { pathWithRedirect } from '../utils/authRedirect.js';

// Pass `allowed` as an array of role strings, e.g. ['admin'] or ['admin', 'marketer'].
export default function RoleBasedRoute({ allowed = [], children }) {
  const { isAuthenticated, role, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loader fullScreen />;
  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search || ''}`;
    return <Navigate to={pathWithRedirect('/login', from)} replace />;
  }
  if (!allowed.includes(role)) return <Navigate to="/" replace />;

  return children;
}
